export { default } from './DocumentModule';
